export default __webpack_public_path__ + "static/media/job-switching-arrow-right.4d5fa0ce.svg";